/* eslint-disable global-require */
import React from 'react';
import Loadable from 'react-loadable';
import { TranslateScope } from '@pegasus/translation';
import { Spacer } from '@pegasus/ui-headers';

import { HeaderWrapper } from 'src/client/components/Header/header';
import { useFlashMessagesWithPrefetch } from 'src/client/components/shared/flash-messages/redux/hooks';
import { useCustomer } from 'src/client/components/Header/customer/redux/hooks';
import { FlashMessageContainerWrapper } from './Core.styles';
import { BaseStyle, NormalizeStyle } from './global-styles';

interface Props {
    children: React.ReactNode;
}

const LoadableFlashMessageContainer = Loadable({
    loader: () => import(/* webpackChunkName: "layout" */ './shared/flash-message-container'),
    loading() {
        return <></>;
    },
});

const LoadableFooter = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "layout" */ '../../components/Footer/wrapper'
        ).then(({ FooterWrapper }) => props => <FooterWrapper {...props} />),
    loading() {
        return <></>;
    },
});

export const CoreWebLayout = ({ children }: Props) => {
    const messages = useFlashMessagesWithPrefetch();
    const isGuest = useCustomer();

    return (
        <>
            <NormalizeStyle />
            <BaseStyle />
            <TranslateScope>
                <HeaderWrapper isGuest={isGuest} />
                <Spacer />
            </TranslateScope>
            <FlashMessageContainerWrapper>
                <Spacer />
                <LoadableFlashMessageContainer messages={messages} />
            </FlashMessageContainerWrapper>
            <>{children}</>
            <TranslateScope>
                <LoadableFooter />
            </TranslateScope>
        </>
    );
};
